/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export type API50807Item = {};
    
  



export interface API50807Req {
  
  /** 字典类型,BizDomain=>业务域,BizType=>业务类型,OwnerType=>数据归属者类型,TaskLinkType=>关联任务类型,messageNotifyRuleType=>消息提醒策略类型 */
  dictType?: string;
    
  /** 默认 */
  isDefault?: string;
    
};



export interface API50807Res {
  /** T  */
  list?: API50807Item[];
  
};


// 50807 获取字典数据

export interface IUseGetAPI50807Return {
  /** 获取字典数据: 接口请求状态 */
  isAPI50807Loading: boolean;
  /** 获取字典数据: 接口请求返回数据 */
  dataAPI50807: API50807Res;
  /**  获取字典数据: 接口数据请求方法 */
  fetchAPI50807Data:  (inputs: API50807Req, config?: YWRequestConfig) => Promise<API50807Res>;
  /** 获取字典数据: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI50807 = ():IUseGetAPI50807Return => {
  let isMount = true;
  const [isAPI50807Loading, setIsAPI50807Loading] = useState(false);
  const [dataAPI50807, setDataAPI50807] = useState<API50807Res>({} as API50807Res);
  const requestUrl = `${basePath}/team-work/common/listDict`;

  const fetchAPI50807Data = async (inputs: API50807Req, config?: YWRequestConfig): Promise<API50807Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50807Req>) || {}) as API50807Req;
    
  
    if ( isMount ) {
      setIsAPI50807Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API50807Res>(`${basePath}/team-work/common/listDict?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI50807(res || {} as API50807Res);
        setIsAPI50807Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50807Loading(false);
      }
      return false as unknown as API50807Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50807Loading,
    dataAPI50807,
    fetchAPI50807Data,
    requestUrl,
  }
}

